<script>
    import { mapState, mapActions } from "vuex";
    import { metaInfo } from "@/core/MetaInfo";
    import { BRANDS_BREAKPOINT, MEDIA_BREAKPOINT } from "@igarden/settings/breakpoints";
    import MainBanner from "@main/packages/MainBanner";
    import TheMediaList from "@main/packages/TheMediaList";
    import TheBrandsList from "@main/packages/TheBrandsList";
    import HomeAdvantages from "@igarden/components/HomeAdvantages";
    import HomeCatalog from "@igarden/components/HomeCatalog";
    import HomePlants from "@igarden/components/HomePlants";
    import HomeInstruction from "@igarden/components/HomeInstruction";
    import HomeWork from "@igarden/components/HomeWork";

    export default {
        name: "Home",
        components: {
            HomeWork,
            HomeInstruction,
            HomePlants,
            MainBanner,
            TheBrandsList,
            TheMediaList,
            HomeAdvantages,
            HomeCatalog,
        },
        data() {
            return {
                breakpointsForBrands: BRANDS_BREAKPOINT,
                breakpointsForMedia: MEDIA_BREAKPOINT,
            };
        },
        computed: {
            ...mapState("Root", ["banners", "brands", "media"]),
        },
        mounted() {
            if (!this.banners.length) {
                this.getBanners();
            }

            if (!this.media.length) {
                this.getMedia();
            }

            if (!this.brands.length) {
                this.getBrands();
            }
        },
        methods: {
            ...mapActions("Root", ["getBanners", "getBrands", "getMedia"]),
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="home-page">
        <div class="l-container">
            <div class="home-page__banner">
                <main-banner :banners="banners" bullet-type="circle"></main-banner>
            </div>

            <div class="home-page__advantages">
                <home-advantages></home-advantages>
            </div>

            <div class="home-page__wrap">
                <home-catalog></home-catalog>
            </div>

            <div class="home-page__wrap">
                <home-plants></home-plants>
            </div>

            <div class="home-page__wrap">
                <home-instruction></home-instruction>
            </div>

            <div class="home-page__wrap">
                <home-work></home-work>
            </div>

            <template v-if="brands.length > 0">
                <h2 class="home-page__title page-title">Где купить</h2>
                <div class="home-page__wrap home-page__wrap--brands">
                    <the-brands-list
                        :brands-list="brands"
                        :breakpoints="breakpointsForBrands"
                    ></the-brands-list>
                </div>
            </template>

            <div v-if="media.length > 0" id="media" class="home-page__wrap">
                <div class="home-page__media">
                    <h2 class="home-page__title page-title">Медиа о нас</h2>
                    <the-media-list
                        :media-list="media"
                        :breakpoints="breakpointsForMedia"
                    ></the-media-list>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "~@main/packages/TheSlider/animated-dots.scss";

    .home-page {
        padding-bottom: 40px;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            position: relative;
            padding-bottom: 56px;
        }
    }

    .home-page__title {
        margin-bottom: 24px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 40px;
        }
    }

    .home-page__banner {
        margin: 0 -16px 26px;

        @include bp($bp-desktop-sm) {
            margin: 40px 0 34px;
        }
    }

    .home-page__advantages {
        margin-bottom: 56px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 46px;
        }
    }

    .home-page__wrap {
        margin-bottom: 56px;
    }

    .home-page__media {
        margin-left: -16px;
        margin-right: -16px;
        padding: 0 16px;

        .media-card {
            width: 230px;
            padding-right: 0;
        }
    }

    //
    // --mod
    //

    .home-page__wrap--brands {
        .c-slider__arrow {
            top: 41%;
        }
    }
</style>
